<mat-toolbar *ngIf="!showWaiting && isDrawMode">
  <div class="submit-banner">
    <span *ngIf="isDrawMode">Word to Draw: {{ wordToDraw }}</span>
    <div class="pull-right">
      <pbg-timer (timerChange)="timerChangeHandler($event)" [timeLimit]="timeLimit" [endTime]="expiration"></pbg-timer>
    </div>
  </div>
</mat-toolbar>

<div class="page-container" [class.has-footer]="showReady">
  <div *ngIf="showReady || showWaiting || waitMode" class="avatar-container">
    <img class="avatar" src="{{ user.avatar }}" />
    <p><strong>{{ user.name }}</strong></p>

    <div *ngIf="showReady">
      <p>Wait until all users are logged in and then click Ready!</p>
    </div>

    <p *ngIf="waitMode">Hang tight until your friends submit their pictures or guesses.</p>
    <p *ngIf="showWaiting">
      Sit tight and relax...
    </p>
  </div>

  <div *ngIf="!showWaiting">
    <div *ngIf="isDrawMode">
      <pbg-drawing-pad #drawingPad [wordToDraw]="wordToDraw" (savedImage)="sendResponse($event)"></pbg-drawing-pad>
    </div>

    <div class="guess-container" *ngIf="isGuessMode">
      <input [(ngModel)]="guess" type="text" class="form-control" placeholder="Guess the Picture" />
      <button (click)="sendResponse(guess)" class="btn btn-primary">Submit</button>
      <img #guessPicture [src]="pictureHash">
    </div>
  </div>
</div>

<div class="footer-bar-container" *ngIf="showReady">
  <div class="footer-bar-content">
    <!-- <button *ngIf="submitMode" mat-raised-button color="primary" class="full-width" (click)="submitSubmissions()">Submit</button>
    <button *ngIf="voteMode" mat-raised-button color="primary" class="full-width" (click)="submitVote()">Submit</button> -->
    <button *ngIf="showReady" mat-raised-button color="primary" class="ready-button full-width" (click)="onReadyHandler()">Ready!</button>
  </div>
</div>
